module.exports = __webpack_public_path__ + "img/highpress.63eebc13.png";